import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/index.html',
    name: 'homeWithHtml',
    component: HomeView
  },
]
const isCy = process.env.VUE_APP_IS_CY === 'true';
// 必须与 vue.config.js 的 publicPath 完全一致：以 / 开头、末尾加 /
const base = isCy ? '/kndxf/20260202/' : '/kndfxfyy-wg/20260205/';
const router = new VueRouter({
  routes,
  mode: 'history',
  base,
})
// 恢复 push 方法的错误处理
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
  return routerPush.call(this, location).catch((err) => {});
};
export default router
